import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import moment from 'moment';

// Components
import DatePicker from 'react-datepicker';
import {Icon} from '@social-native/snclient-ui';

require('react-datepicker/dist/react-datepicker.css');

const dateRanges = {
    'All Time': true,
    'This Week': [
        moment()
            .startOf('week')
            .unix(),
        moment()
            .endOf('week')
            .unix()
    ],
    'Last Week': [
        moment()
            .startOf('week')
            .subtract(1, 'week')
            .unix(),
        moment()
            .startOf('week')
            .unix()
    ],
    'This Month': [
        moment()
            .startOf('month')
            .unix(),
        moment()
            .endOf('month')
            .unix()
    ],
    'Last Month': [
        moment()
            .startOf('month')
            .subtract(1, 'month')
            .unix(),
        moment()
            .startOf('month')
            .unix()
    ],
    'Last 3 Days': [
        moment()
            .startOf('day')
            .subtract(3, 'days')
            .unix(),
        moment()
            .endOf('day')
            .unix()
    ],
    'Last 7 Days': [
        moment()
            .startOf('day')
            .subtract(7, 'days')
            .unix(),
        moment()
            .endOf('day')
            .unix()
    ],
    'Last 14 Days': [
        moment()
            .startOf('day')
            .subtract(14, 'days')
            .unix(),
        moment()
            .endOf('day')
            .unix()
    ],
    'Last 30 Days': [
        moment()
            .startOf('day')
            .subtract(30, 'days')
            .unix(),
        moment()
            .endOf('day')
            .unix()
    ],
    Custom: [moment().unix(), moment().unix()]
};

class DateRangePicker extends Component {
    constructor() {
        super();
        this.state = {
            showDatePickers: false
        };
    }

    handleDateChange = e => {
        const {onChange, showBidAndBudgetRow} = this.props;
        const selectedIndex = e.target.value;
        const value = Object.values(dateRanges)[selectedIndex];

        if (value === true) {
            this.setState({
                showDatePickers: false
            });

            onChange(null, null, selectedIndex);
            showBidAndBudgetRow(false);
        } else if (value === null) {
            this.setState({
                showDatePickers: true
            });

            showBidAndBudgetRow(true);
        } else {
            this.setState({
                showDatePickers: false
            });

            onChange(value[0], value[1], selectedIndex);
            showBidAndBudgetRow(true);
        }
    };

    handleStartChange = date => {
        if (R.isNil(date)) return;
        const {selectedEnd, onChange} = this.props;
        const selectedIndex = R.indexOf('Custom', Object.keys(dateRanges));

        if (onChange) {
            // Passing selectedIndex keeps date options visible (Custom)
            onChange(date.startOf('day').unix(), selectedEnd, selectedIndex);
        }
    };

    handleEndChange = date => {
        if (R.isNil(date)) return;
        const {selectedStart, onChange} = this.props;
        const selectedIndex = R.indexOf('Custom', Object.keys(dateRanges));

        if (onChange) {
            // Passing selectedIndex keeps date options visible (Custom)
            onChange(selectedStart, date.endOf('day').unix(), selectedIndex);
        }
    };

    displayDateOptions() {
        const mapIndexed = R.addIndex(R.map);
        return mapIndexed(
            (option, idx) => (
                <option key={idx} value={idx}>
                    {option}
                </option>
            ),
            Object.keys(dateRanges)
        );
    }

    displayStartDatePicker() {
        const {showDatePickers} = this.state;
        const {dateSelectActive} = this.props;

        if (showDatePickers || dateSelectActive) {
            return (
                <DatePicker
                    className=""
                    selected={moment.unix(this.props.selectedStart)}
                    onChange={this.handleStartChange}
                />
            );
        }
        return null;
    }

    displayEndDatePicker() {
        const {showDatePickers} = this.state;
        const {dateSelectActive} = this.props;

        if (showDatePickers || dateSelectActive) {
            return (
                <DatePicker
                    className=""
                    selected={moment.unix(this.props.selectedEnd)}
                    onChange={this.handleEndChange}
                    popoverAttachment="bottom right"
                    popoverTargetAttachment="top right"
                />
            );
        }
        return null;
    }

    render() {
        const {dateSelectedIdx} = this.props;
        const dateOptions = this.displayDateOptions();
        const dateStartPicker = this.displayStartDatePicker();
        const dateEndPicker = this.displayEndDatePicker();

        return (
            <div className="date-range-picker">
                <select
                    className="dropdown-toggle"
                    onChange={this.handleDateChange}
                    value={dateSelectedIdx}
                >
                    {dateOptions}
                </select>
                <Icon icon="caret-down" className="icon" />
                {dateStartPicker}
                {dateEndPicker}
            </div>
        );
    }
}

DateRangePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    showBidAndBudgetRow: PropTypes.func.isRequired
};

export default DateRangePicker;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/date_range_picker.js